const compactFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
})

const preciseFormatter = new Intl.NumberFormat('en-US')

export function formatCompact(value: number): string {
  return value < 10_000 ? preciseFormatter.format(value) : compactFormatter.format(value)
}

export function formatPrecise(value: number): string {
  return preciseFormatter.format(value)
}

export function timeAgo(isoString: string | null): string {
  if (!isoString) return 'never'

  const seconds = Math.max(0, (Date.now() - new Date(isoString).getTime()) / 1000)
  if (seconds < 60) return 'just now'
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`
  if (seconds < 86_400) return `${Math.floor(seconds / 3600)}h ago`
  return `${Math.floor(seconds / 86_400)}d ago`
}
